// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uhig0Q {
  background: var(--surface-neutral-white, #ffffff);
  border-radius: var(--radius-s, 4px);
  box-shadow: var(--shadow-s, 0 2px 4px 0 rgba(0, 0, 0, 0.12));
  min-height: calc(100vh - 155px);
  font-family: var(--font-family-base);
}

.eiRKwl {
  margin: 0;
  padding: var(--spacing-3) var(--spacing-3) var(--spacing-2) var(--spacing-3);
  border-bottom: 1px solid var(--border-neutral-soft, #e5e7eb);
  font-family: var(--font-family-base);
  font-size: var(--ibk-typography-fontSizeMd, 16px);
  font-weight: var(--type-paragraph-lg-regular-font-weight, 600);
  line-height: var(--type-paragraph-lg-regular-line-height, 24px);
  color: var(--text-neutral-dark);
}

.EynWbx {
  display: flex;
  flex-direction: column;
  padding: var(--spacing-3, 24px);
}

.t9LTnU {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1-5, 12px);
  margin-bottom: var(--spacing-1-5);
}

.h9Sf8K {
  height: 1px;
  background: var(--border-neutral-soft, #e5e7eb);
  margin: var(--spacing-2, 16px) 0;
}

.t9LTnU:last-child .h9Sf8K {
  display: none;
}

.r6e1GH {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1, 8px);
}

.XSJoQS {
  display: flex;
  align-items: center;
  position: relative;
}

.P6BCx9 {
  display: flex;
  align-items: center;
  gap: var(--spacing-1, 8px);
  flex: 1;
}

.KwPATh {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}

.ymgvDP {
  width: 24px;
  height: 24px;
}

.j_L8N2 {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--type-label-md-font-size);
  line-height: 1;
  align-items: center;
  justify-content: center;
  display: inline-flex;
  width: 24px;
  height: 24px;
  border-radius: 12px;
  background: var(--icon-primary-medium);
  color: var(--icon-neutral-white);
}

.zm0UsH {
  color: var(--text-neutral-dark);
  font-family: var(--font-family-base);
  font-size: var(--ibk-typography-fontSizeMd, 16px);
  font-weight: var(--type-label-lg-regular-font-weight);
  line-height: var(--line-height-180);
}

.h9_dYN {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0-5, 4px);
  margin-top: 15px;
}

.MdboXl {
  display: flex;
  align-items: baseline;
  font-size: var(--font-size-md);
  line-height: var(--type-paragraph-sm-line-height, 16px);
  gap: 5px;
}

.ltuwWS {
  font-weight: var(--type-label-lg-regular-font-weight);
  color: var(--text-neutral-dark);
  flex-shrink: 0;
  font-size: var(--font-size-md);
  width: 130px;
  line-height: var(--line-height-180);
}

.EwBpek {
  font-weight: var(--type-label-lg-font-weight);
  color: var(--text-neutral-dark);
  margin-left: var(--spacing-1, 8px);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
}

.Aql6EM {
  display: block;
  color: var(--text-neutral-stronger);
  font-size: var(--type-label-sm-font-size);
  margin-top: var(--spacing-3);
  font-weight: normal;
}

.aPHLBh {
  background: none;
  border: none;
  color: var(--text-primary-medium);
  cursor: pointer;
  font-size: var(--font-size-md);
  font-weight: var(--type-label-lg-regular-font-weight);
  text-decoration: underline;
  padding: 0;
  margin-left: var(--spacing-0-5, 4px);
}

.aPHLBh:hover {
  color: var(--text-primary-strong);
  text-decoration: underline;
}

.aPHLBh:focus {
  outline: 2px solid var(--border-primary-medium);
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/RechargeSidebar/RechargeSidebar.module.css"],"names":[],"mappings":"AAAA;EACE,iDAAiD;EACjD,mCAAmC;EACnC,4DAA4D;EAC5D,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,4EAA4E;EAC5E,4DAA4D;EAC5D,oCAAoC;EACpC,iDAAiD;EACjD,8DAA8D;EAC9D,+DAA+D;EAC/D,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,+CAA+C;EAC/C,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,yCAAyC;EACzC,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,iDAAiD;EACjD,qDAAqD;EACrD,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,uDAAuD;EACvD,QAAQ;AACV;;AAEA;EACE,qDAAqD;EACrD,+BAA+B;EAC/B,cAAc;EACd,8BAA8B;EAC9B,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,6CAA6C;EAC7C,+BAA+B;EAC/B,kCAAkC;EAClC,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,yCAAyC;EACzC,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iCAAiC;EACjC,eAAe;EACf,8BAA8B;EAC9B,qDAAqD;EACrD,0BAA0B;EAC1B,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;AACrB","sourcesContent":[".summaryCard {\n  background: var(--surface-neutral-white, #ffffff);\n  border-radius: var(--radius-s, 4px);\n  box-shadow: var(--shadow-s, 0 2px 4px 0 rgba(0, 0, 0, 0.12));\n  min-height: calc(100vh - 155px);\n  font-family: var(--font-family-base);\n}\n\n.summaryTitle {\n  margin: 0;\n  padding: var(--spacing-3) var(--spacing-3) var(--spacing-2) var(--spacing-3);\n  border-bottom: 1px solid var(--border-neutral-soft, #e5e7eb);\n  font-family: var(--font-family-base);\n  font-size: var(--ibk-typography-fontSizeMd, 16px);\n  font-weight: var(--type-paragraph-lg-regular-font-weight, 600);\n  line-height: var(--type-paragraph-lg-regular-line-height, 24px);\n  color: var(--text-neutral-dark);\n}\n\n.summarySteps {\n  display: flex;\n  flex-direction: column;\n  padding: var(--spacing-3, 24px);\n}\n\n.summarySection {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1-5, 12px);\n  margin-bottom: var(--spacing-1-5);\n}\n\n.summaryDivider {\n  height: 1px;\n  background: var(--border-neutral-soft, #e5e7eb);\n  margin: var(--spacing-2, 16px) 0;\n}\n\n.summarySection:last-child .summaryDivider {\n  display: none;\n}\n\n.summaryStep {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1, 8px);\n}\n\n.stepWrapper {\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n\n.stepHeader {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1, 8px);\n  flex: 1;\n}\n\n.stepIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n}\n\n.stepIconCompleted {\n  width: 24px;\n  height: 24px;\n}\n\n.stepIconPending {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--type-label-md-font-size);\n  line-height: 1;\n  align-items: center;\n  justify-content: center;\n  display: inline-flex;\n  width: 24px;\n  height: 24px;\n  border-radius: 12px;\n  background: var(--icon-primary-medium);\n  color: var(--icon-neutral-white);\n}\n\n.stepLabel {\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-base);\n  font-size: var(--ibk-typography-fontSizeMd, 16px);\n  font-weight: var(--type-label-lg-regular-font-weight);\n  line-height: var(--line-height-180);\n}\n\n.stepContent {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-0-5, 4px);\n  margin-top: 15px;\n}\n\n.stepDataItem {\n  display: flex;\n  align-items: baseline;\n  font-size: var(--font-size-md);\n  line-height: var(--type-paragraph-sm-line-height, 16px);\n  gap: 5px;\n}\n\n.stepDataLabel {\n  font-weight: var(--type-label-lg-regular-font-weight);\n  color: var(--text-neutral-dark);\n  flex-shrink: 0;\n  font-size: var(--font-size-md);\n  width: 130px;\n  line-height: var(--line-height-180);\n}\n\n.stepDataValue {\n  font-weight: var(--type-label-lg-font-weight);\n  color: var(--text-neutral-dark);\n  margin-left: var(--spacing-1, 8px);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n}\n\n.stepDataAnnotation {\n  display: block;\n  color: var(--text-neutral-stronger);\n  font-size: var(--type-label-sm-font-size);\n  margin-top: var(--spacing-3);\n  font-weight: normal;\n}\n\n.viewBeneficiariesLink {\n  background: none;\n  border: none;\n  color: var(--text-primary-medium);\n  cursor: pointer;\n  font-size: var(--font-size-md);\n  font-weight: var(--type-label-lg-regular-font-weight);\n  text-decoration: underline;\n  padding: 0;\n  margin-left: var(--spacing-0-5, 4px);\n}\n\n.viewBeneficiariesLink:hover {\n  color: var(--text-primary-strong);\n  text-decoration: underline;\n}\n\n.viewBeneficiariesLink:focus {\n  outline: 2px solid var(--border-primary-medium);\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"summaryCard": `uhig0Q`,
	"summaryTitle": `eiRKwl`,
	"summarySteps": `EynWbx`,
	"summarySection": `t9LTnU`,
	"summaryDivider": `h9Sf8K`,
	"summaryStep": `r6e1GH`,
	"stepWrapper": `XSJoQS`,
	"stepHeader": `P6BCx9`,
	"stepIcon": `KwPATh`,
	"stepIconCompleted": `ymgvDP`,
	"stepIconPending": `j_L8N2`,
	"stepLabel": `zm0UsH`,
	"stepContent": `h9_dYN`,
	"stepDataItem": `MdboXl`,
	"stepDataLabel": `ltuwWS`,
	"stepDataValue": `EwBpek`,
	"stepDataAnnotation": `Aql6EM`,
	"viewBeneficiariesLink": `aPHLBh`
};
module.exports = ___CSS_LOADER_EXPORT___;
